export const SLICE_NAME = 'game';

export const RESET_GAME = `${SLICE_NAME}/RESET_GAME`;
export const FETCH_NAME = `${SLICE_NAME}/FETCH_NAME`;
export const START_GAME = `${SLICE_NAME}/START_GAME`;
export const FINISH_GAME = `${SLICE_NAME}/FINISH_GAME`;
export const CHANGE_VOLUME = `${SLICE_NAME}/CHANGE_VOLUME`;
export const SET_LEVEL = `${SLICE_NAME}/SET_LEVEL`;
